import * as React from 'react';
import { Backdrop, Box, Button, Card,CardActions,CardContent, CardMedia, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Slide, Stack, Typography } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InfoIcon from '@mui/icons-material/Info';
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function Roulettes() {
    const navigate = useNavigate();

    const {state} = useLocation()
    const [rows, setRows] = React.useState(state.data);
    const [open, setOpen] = React.useState(false);
    const [row, setRow] = React.useState(state.data);


    function timeStampToDate(unix_timestamp){

        const timestamp = unix_timestamp.fecha._seconds
        // Create a new JavaScript Date object based on the timestamp
        // multiplied by 1000 so that the argument is in milliseconds, not seconds
        var date = new Date(timestamp * 1000);

        // Hours part from the timestamp
        const year = date.getFullYear();

        // Minutes part from the timestamp
        const month = "0" + date.getMonth();

        // Seconds part from the timestamp
        const day = "0" + date.getDay();

        // Will display time in 10:30:23 format
        var formattedTime = day + '/' + month + '/' + year;

        return formattedTime
    }

    function onClickDoGame(row){
        setRow(row)
        setOpen(true)
    }
    const handleCloseNo = () => {
        setOpen(false);
    }
    const handleCloseYes = () => {
        setOpen(false);
        
        navigate('/main/home/roulettes/roulette', {state: row});
    }

    return (
        <Box sx={{ flexGrow: 1, overflow: 'hidden', px: 2, }}>    
            <div sx={{ my: 1, mx: 'auto'}}>
                <Stack spacing={2} sx={{mt:8}}> 
                    {rows?.map((row) => (
                        <Card sx={{ borderRadius:2}} variant='paper'>
                        <CardContent>
                            <Typography color={"black"} gutterBottom variant='h5' sx={{fontWeight:"bolder"}}>
                            {row.nombre}
                            </Typography>
                            
                            <Stack spacing={2} sx={{pb:1}} direction={"row"}>
                                {row.puntos > 0?
                                    <Typography color={"black"} sx={{fontSize: 18, fontWeight: "bold"}}> ¡Ganas {row.puntos} Puntos!</Typography>
                                    :
                                    <></>
                                }
                                
                            </Stack>
                           
                        </CardContent>
                        <CardActions>
                            <Button  onClick={()=>onClickDoGame(row)} variant='secondary'>Jugar</Button>
                        </CardActions>
                    </Card>
                    ))}
                </Stack>
                <Backdrop
                  sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
                  open={open}
                >
                  <CircularProgress color="inherit" />
                </Backdrop>
              
            </div>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                keepMounted
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>Guna Lealtad</DialogTitle>
                <DialogContent>
                <DialogContentText id="alert-dialog-description">
                ¿Estas seguro que deseas jugar este ruleta?
                </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button color="secondary" onClick={handleCloseNo}>No</Button>
                    <Button color="secondary"  onClick={handleCloseYes} autoFocus>
                        Si
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    )
}